import React from 'react';
import { Box, Pagination } from '@mui/material';

const PaginationComponent = ({
  totalItems,
  perPage,
  currentPage,
  handlePageChange,
}) => {
  // Calculate the total number of pages
  const totalPages = Math.ceil(totalItems / perPage);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={3}
      mb={3}
    >
      <Pagination
        count={totalPages} // Calculate total pages
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
      />
    </Box>
  );
};

export default PaginationComponent;
